export default function getAssetsFromStoreByIds(ids, assets) { return ids.map((id) => assets.find((asset) => asset._id === id)); }
